module.exports = __webpack_public_path__ + "img/register-v2.5a35fe19.svg";